<template>
	<div>
		<b-img src="/images/importer/module-basic-info/basic-info.jpg"></b-img>
		<p>
			The Basic Info module is the starting point for working with the Character Importer.
		</p>

		<p>
			<span class="font-weight-bold">Input Directory:</span> This is the directory in your Project where your character's files are located - meshes, textures, materials, etc. This should
			not be the main Assets folder but a subdirectory inside it, and cannot contain any Scene or Script files.
		</p>

		<p>
			<span class="font-weight-bold">Output Directory:</span> This is the directory in your Project where the .fdc (FarmD Character) package files will be built when you press the Build 
			Character Package button. This should be an empty folder - all files in it will be generated when building the character package.
		</p>
        
		<p>
			<span class="font-weight-bold">Species Group Name:</span> This is used to group character species together in the Character Menu in-game. The built-in characters use a group of "standard",
			but you can give your species any group name you like. For example, if you are building multiple characters and want to have them grouped together in the game, or you are planning to share
			your character file with others, you may use this Group as a kind of "Author" name field.
		</p>
        
		<p>
			<span class="font-weight-bold">Species Name:</span> The name of your character species. This should be unique within its Group to prevent name collisions with any other species.
		</p>
        
		<p>
			<span class="font-weight-bold">Body Orientation:</span> This indicates what kind of body type your character has. <span class="font-weight-bold">Anthro</span> characters are bipedal or 
			humanoid, while <span class="font-weight-bold">Feral</span> characters are quadrupedal.
		</p>
        
		<p>
			<span class="font-weight-bold">Leg Orientation:</span> This will alter some leg rigging and animations in-game to make them more correct for the selected leg type. For anthro characters, a
			digitigrade character is one that walks on its toes, and a plantigrade character walks with its feet flat on the ground.
		</p>
        
		<p>
			<span class="font-weight-bold">Character Model:</span> This should be the character's model object, which should be added to the scene as a child of the CharacterImporter object.
		</p>
        
		<p>
			<span class="font-weight-bold">Show/Hide Scale Reference:</span> This toggle button will show or hide a guide mesh that indicates how large your character should be in order for it to match 
			up correctly with the existing characters and animations. If you need to adjust the size of your character to match it, scale the Character Model object, not the Character Importer object. Also,
			adjust all axes of the character model (X,Y,Z) equally when scaling. For Anthro characters, try to line up the character's head with the scale reference. However, this may not give the best 
			results for some digitigrade characters due to the differences in leg length - in this case you should try to match up the length of the character's torso to match the scale reference. 
			For Feral characters, it's best to match up the top of the character's back with the scale reference.
		</p>
	</div>
</template>

<script>
export default {
		name: 'BasicInfoModule',
}
</script>
